import axios from "axios";
const Instance = axios.create({
  baseURL: "https://jozardan-company.com/",
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
  },
});
export default Instance;
